"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaddingLevel = void 0;
var PaddingLevel = {
  NONE: 'none',
  COMPRESSED: 'compressed',
  CONDENSED: 'condensed',
  REGULAR: 'regular',
  EXPANDED: 'expanded'
};
exports.PaddingLevel = PaddingLevel;